type TJoinAnswersProps = {
  drugOrAlcoholExplanation?: string;
  amphetaminesExplanation?: string;
  opiatesExplanation?: string;
  marijuanaExplanation?: string;
  cocaineExplanation?: string;
  pcpExplanation?: string;
  otherDrugsExplanation?: string;
};

export const joinAnswers = (answers: TJoinAnswersProps) => {
  const answersMap = new Map<string, string | undefined>(
    Object.entries(answers)
  );
  return Object.keys(answers)
    .map((answerKey: string, index) => {
      const answer = answersMap.get(answerKey);
      if (answer) {
        return `Q${index + 1}: ${answer}`;
      }
      return '';
    })
    .filter(Boolean)
    .join('; ');
};
